import React from "react"
import S from "./style"

const Delivery = () => {
    return(
        <S.Container1>
            <S.Overlay></S.Overlay>
            <S.DeliveryContainer>
                <S.DeliveryHeading>Order through one of these Food Delivery Apps: </S.DeliveryHeading>
                <S.DeliveryLink href="https://www.grubhub.com/restaurant/sushi-gallery-16436-norwalk-blvd-cerritos/2053881" target="_blank" title="Grubhub">
                    <S.DeliveryImage src="https://static.wixstatic.com/media/db1b50_35240fd360014d39a5e4036505833436~mv2.png/v1/fill/w_442,h_228,al_c,lg_1,q_85,enc_auto/button-grubhub.png" ></S.DeliveryImage>
                </S.DeliveryLink>
                <S.DeliveryLink href="https://postmates.com/merchant/sushi-gallery-cerritos" target="_blank" title="Postmates">
                    <S.DeliveryImage src="https://images.squarespace-cdn.com/content/v1/57977ed61b631b286ea33723/1588529095947-OH7HO7EQA5L2DM4DT0WO/button-postmates.png"></S.DeliveryImage>
                </S.DeliveryLink>
                <S.DeliveryLink href="https://www.ubereats.com/los-angeles/food-delivery/sushi-gallery/o3Ph-roTR1SnxAhvKAEIkA" target="_blank" title="Uber Eats">
                    <S.DeliveryImage src="https://images.squarespace-cdn.com/content/v1/5c89392b7d0c913d346532c7/1579040542246-PT5FY9ZVTSD1BHUKOBUC/ke17ZwdGBToddI8pDm48kHwVRMbgD4xuxk8wSx9uTtZZw-zPPgdn4jUwVcJE1ZvWEtT5uBSRWt4vQZAgTJucoTqqXjS3CfNDSuuf31e0tVHoPIrBR5F6J03dLhMIV0FsThI58P6_y3TPWhpJtU9Cme87Nsj43NRAr6WuWZv5DKs/button-ubereats.png"></S.DeliveryImage>
                </S.DeliveryLink>
            </S.DeliveryContainer>
        </S.Container1>
    )
}

export default Delivery